import Badge from "../../../components/ui/Badge";
import { formatManilaTime } from "../../../utils/manilaTime";
import { formatHours } from "../../../utils/date";
import { cx } from "../../../utils/classNames";
import { SOURCE_LABELS } from "../sessionUtils";
import SessionStatusBadge from "./SessionStatusBadge";
import styles from "../Sessions.module.css";

// One row per check-in period, oldest first. `renderExtra(session)` adds
// content under a row (the locations modal uses it for the points).
const SessionTimeline = ({ sessions = [], renderExtra }) => {
  if (!sessions.length) return null;

  return (
    <ol className={styles.timeline}>
      {sessions.map((session, index) => {
        const isOpen = !session.checkOutTime;
        const isRejected = session.status === "REJECTED";

        return (
          <li
            key={session.id ?? `legacy-${index}`}
            className={cx(styles.session, isOpen && styles.sessionOpen)}
          >
            <span className={styles.sessionIndex}>{index + 1}</span>

            <div className={styles.sessionHead}>
              <span
                className={cx(
                  styles.sessionTimes,
                  isRejected && styles.rejected,
                )}
              >
                {formatManilaTime(session.checkInTime)} →{" "}
                {isOpen ? "now" : formatManilaTime(session.checkOutTime)}
              </span>
              {session.hours > 0 && (
                <span className={styles.sessionPartHours}>
                  {formatHours(session.hours)} this check-in
                </span>
              )}
              <span className="d-inline-flex flex-wrap gap-1">
                {isOpen && (
                  <Badge tone="blue" icon="bi-record-circle">
                    Checked in
                  </Badge>
                )}
                <SessionStatusBadge status={session.status} />
                {session.source &&
                  !["WEB", "MOBILE"].includes(session.source) && (
                    <Badge tone="purple">
                      {SOURCE_LABELS[session.source] ?? session.source}
                    </Badge>
                  )}
              </span>
            </div>

            {session.clientName && (
              <div className={styles.sessionNote}>
                <i className="bi bi-briefcase me-1"></i>
                Client: {session.clientName}
              </div>
            )}
            {session.statusReason && (
              <div className={styles.sessionReason}>
                <i className="bi bi-geo-alt me-1"></i>
                {session.statusReason}
              </div>
            )}
            {isRejected && (
              <div className={styles.sessionNote}>
                Not counted in your hours.
              </div>
            )}
            {session.checkIn?.note && (
              <div className={styles.sessionNote}>
                <i className="bi bi-box-arrow-in-right me-1"></i>
                In: {session.checkIn.note}
              </div>
            )}
            {session.checkOut?.note && (
              <div className={styles.sessionNote}>
                <i className="bi bi-box-arrow-right me-1"></i>
                Out: {session.checkOut.note}
              </div>
            )}
            {/* Older records: one remarks field for the session */}
            {session.remarks &&
              !session.checkIn?.note &&
              !session.checkOut?.note && (
                <div className={styles.sessionNote}>
                  <i className="bi bi-chat-left-text me-1"></i>
                  {session.remarks}
                </div>
              )}
            {session.reviewRemarks && (
              <div className={styles.sessionNote}>
                <i className="bi bi-person-check me-1"></i>
                Reviewer: {session.reviewRemarks}
              </div>
            )}

            {renderExtra?.(session)}
          </li>
        );
      })}
    </ol>
  );
};

export default SessionTimeline;
